import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { withStateHandlers } from 'recompose';
import moment from 'moment';
import './Calendar.css';
import DateInput from './DateInput';

const Calendar = ({
  selectedDate,
  opened,
  handleChange,
  handleOpen,
  handleClose,
}) => (
  <div className="Calendar">
    <DatePicker
      selected={moment(selectedDate)}
      dateFormat="DD MMMM YYYY"
      maxDate={moment()}
      customInput={
        <DateInput
          inputClass={`date-input${opened ? '-open' : ''}`}
          onOpen={handleOpen}
        />
      }
      onSelect={handleChange}
      onClickOutside={handleClose}
    />
  </div>
);

export default withStateHandlers(
  ({ selectedDate, opened = false }) => ({
    selectedDate,
    opened,
  }),
  {
    handleChange: (state, { onChange }) => selectedDate => {
      if (onChange) {
        onChange(selectedDate.toDate());
      }
      return { selectedDate, opened: false };
    },
    handleOpen: () => () => ({ opened: true }),
    handleClose: () => () => ({ opened: false }),
  },
)(Calendar);



// WEBPACK FOOTER //
// ./src/components/Calendar/Calendar.jsx